import React from "react";
const AppHeading1=({children})=>{
    return(
        <h1 className="font-semibold text-24px leading-32px tracking-0.02em capitalize">{children}</h1>
    )
}

export default AppHeading1

